import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  DATA_MIGRATION_UPGRADE,
  DOCUMENTATION_ONLY,
  INFRASTRUCTURE_UPGRADE,
  MAINTENANCE_CHANGE,
  MAJOR_INFRA_UPGRADE,
  NEW_PRODUCT_PROJECT,
  PRODUCT_UPGRADE_ROLLOUT,
  SOFTWARE_UPGRADE,
  STANDALONE_CHARGE,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const fieldId = 'change-scope-technology';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = null;

const vFParams = {
  fieldTitle: 'Change scope - technology?',
  placeholder: 'Please select',
};


const riskLevelParams = {
  weight: 0.2,
  score: {
    [DATA_MIGRATION_UPGRADE]: 3,
    [DOCUMENTATION_ONLY]: 1,
    [INFRASTRUCTURE_UPGRADE]: 3,
    [MAINTENANCE_CHANGE]: 3,
    [MAJOR_INFRA_UPGRADE]: 4,
    [NEW_PRODUCT_PROJECT]: 4,
    [PRODUCT_UPGRADE_ROLLOUT]: 3,
    [SOFTWARE_UPGRADE]: 3,
    [STANDALONE_CHARGE]: 3,
  },
};

const changeScopeTechnology = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_DROPDOWN,
};

export { changeScopeTechnology };
